import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DiretorioEmpresas } from '@/components/marketplace/DiretorioEmpresas';

export default function Empresas() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-background">
      <header className="flex items-center justify-between px-4 h-14 border-b border-border">
        <Link to="/" className="font-bold">{t('marketplace.brand')}</Link>
        <Link to="/auth" className="ow-btn ow-btn--ghost">{t('marketplace.signIn')}</Link>
      </header>
      <main className="max-w-5xl mx-auto p-4">
        <h1 className="text-2xl font-bold mb-1">{t('marketplace.title')}</h1>
        <p className="text-sm text-muted-foreground mb-4">{t('marketplace.subtitle')}</p>
        <DiretorioEmpresas />
      </main>
    </div>
  );
}
